import Head from "next/head";
import MorePosts from "@/components/blog/more-posts";
import Header from "@/components/blog/header";
import Layout from "@/components/layout";
import { landingPagesQuery, blogQuery } from "@/lib/queries";
import { getClient, overlayDrafts } from "@/lib/sanity.server";
import { getSegmentProps } from "@/components/segment-generator";
import SegmentContainer from "@/components/segments/segment-container";

export default function Blog({ blogMetaContent, allPosts, preview }) {
  const headerSegment = blogMetaContent.segments?.find((segment) =>
    segment.name.toLowerCase().includes("header")
  );

  // const featuredPost = allPosts[0];
  // const morePosts = allPosts.slice(1);
  return (
    <>
      <Layout preview={preview}>
        <Head>
          <title>{blogMetaContent.title}</title>
          <meta name="description" content={blogMetaContent.metaDescription} />
          <meta property="og:title" content={blogMetaContent.title} />
          <meta
            property="og:description"
            content={blogMetaContent.metaDescription}
          />
          <meta
            property="og:url"
            content={`${process.env.NEXT_PUBLIC_HOST}/blog`}
          />
          <meta property="og:type" content="article" />
          <meta
            property="article:modified_time"
            content={blogMetaContent._updatedAt}
          ></meta>
          <meta property="og:site_name" content="JustShip" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:site_name" content={blogMetaContent.title}></meta>
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:label1" content="Est. reading time" />
          <meta name="twitter:data1" content="3 minutes" />
        </Head>
        <Header {...getSegmentProps(headerSegment)} />
        {/* TODO: featured posts in tier 2 tasks */}
        {/* <Container className="bg-background-dark-gray">
          <div className="py-8 lg:py-16">
            <Panel>
              <h2 className="mb-6 text-dark-purple text-2xl lg:text-3xl font-semibold">
                Featured Posts
              </h2>
              <div className="grid grid-cols-2 gap-8">
                {featuredPost && (
                  <FeaturedPost
                    title={featuredPost.title}
                    coverImage={featuredPost.coverImage}
                    date={featuredPost.date}
                    slug={featuredPost.slug}
                    excerpt={featuredPost.excerpt}
                  />
                )}
              </div>
            </Panel>
          </div>
        </Container> */}
        <SegmentContainer className="bg-background-gray py-8 lg:py-16">
          <MorePosts title="Most Recent" posts={allPosts} />
        </SegmentContainer>
      </Layout>
    </>
  );
}

export async function getStaticProps({ preview = false }) {
  const allPosts = overlayDrafts(await getClient(preview).fetch(blogQuery));
  const blogMetaContent = overlayDrafts(
    await getClient(preview).fetch(landingPagesQuery, { slug: "blog" })
  )[0];
  return {
    props: { blogMetaContent, allPosts, preview },
  };
}
